import React, { Component } from 'react';
import PopupContainer from '../../../components/PopupContainer';
import Popup from '../../../components/SimplePopup';
import { withRouter } from 'react-router-dom';
import { API } from '../../../requests';
import moment from 'moment';

import ViewRenderer from './views';
import Spinner from '../../../components/Spinner';
import { commonImages, operatorImages } from '../../../assets/images';
import strings from '../../../globalization';
import { connect } from 'react-redux';

const POPUP_CONSTANTS = {
    STANDARD: 'standard',
    SIMPLE_POPUP: 'simple',
    ERROR: 'error',
    SPINNER_POPUP: 'spinner',
    SUCCESS: 'success',
};

class TransactionReport extends Component {
    constructor(props) {
        super(props);
        const { reduxProps } = this.props;
        const {
            login: { loginInfo },
        } = reduxProps;
        const { company, user } = loginInfo;

        // Set default date range to last 7 days
        const endDate = moment();
        const startDate = moment().subtract(7, 'days');
        const defaultDates = {
            start: startDate.toDate(),
            end: endDate.toDate(),
        };

        this.state = {
            email: '',
            emailError: '',
            company,
            user,
            startDate: startDate.format('MM-DD-YYYY'),
            endDate: endDate.format('MM-DD-YYYY'),
            dates: defaultDates,
            popup: undefined,
            reportData: null,
            showSuccess: false,
            showFailure: false,
            agencyList: [],
            selectedAgencyId: undefined,
        };
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            this.setState({
                popup: undefined,
            });
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    componentDidMount() {
        this.setState({
            popup: undefined,
        });

        this.getActiveAgencies();
    }

    validateEmail = email => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    getActiveAgencies = () => {
        API.getActiveAgencies()
            .then(response => {
                this.setState({
                    agencyList: response.data || [],
                });
            })
            .catch(error => {
                console.log('Error fetching active agencies:', error);
            });
    };

    handleSendReport = () => {
        const { email, startDate, endDate, selectedAgencyId } = this.state;

        // Validate email
        if (!email.trim()) {
            this.setState({ emailError: 'Email is required' });
            return;
        }

        if (!this.validateEmail(email)) {
            this.setState({ emailError: 'Please enter a valid email address' });
            return;
        }

        // Clear error and show loading
        this.setState({
            emailError: '',
            popup: {
                type: POPUP_CONSTANTS.SPINNER_POPUP,
            },
        });

        // Call API
        API.transactionReportWithDateFilter(email, startDate, endDate, selectedAgencyId)
            .then(response => {
                console.log('Transaction report response:', response);
                this.setState({
                    reportData: response.data,
                    showSuccess: true,
                    showFailure: false,
                    popup: undefined,
                });
            })
            .catch(error => {
                console.log('Error fetching transaction report:', error);
                const errorMsg = error.response
                    ? error.response.data.message
                    : error.message;
                console.info('error....', errorMsg);
                this.setState({
                    showSuccess: false,
                    showFailure: true,
                    popup: undefined,
                });
            });
    };

    onChangeHandler = (action, data) => {
        console.log(action, data);
        switch (action) {
            case 'email': {
                this.setState({
                    email: data,
                    emailError: '',
                });
                break;
            }

            case 'agency': {
                this.setState({
                    selectedAgencyId: data,
                });
                break;
            }

            case 'date': {
                console.info('Selected date range:', data);
                this.setState({
                    startDate: data.startDate,
                    endDate: data.endDate,
                    dates: data.dates,
                });
                break;
            }

            default: {
                console.info('case not handled', action);
            }
        }
    };

    onClickHandler = (action, data) => {
        switch (action) {
            case 'sendReport': {
                this.handleSendReport();
                break;
            }

            case 'backToForm': {
                this.setState({
                    showSuccess: false,
                    showFailure: false,
                    email: '',
                    reportData: null,
                });
                break;
            }

            case 'retry': {
                this.setState({
                    showFailure: false,
                });
                break;
            }

            default: {
                console.info('case not handled', action);
            }
        }
    };

    closePopup = () => {
        this.setState({
            popup: undefined,
        });
    };

    getProps = () => {
        const { user } = this.state;
        return {
            onClick: this.onClickHandler,
            onChange: this.onChangeHandler,
            email: this.state.email,
            emailError: this.state.emailError,
            dates: this.state.dates,
            roleId: user.roleId,
            showSuccess: this.state.showSuccess,
            showFailure: this.state.showFailure,
            reportData: this.state.reportData,
            agencyList: this.state.agencyList,
            selectedAgencyId: this.state.selectedAgencyId,
        };
    };

    getPopupContent = () => {
        const { popup } = this.state;
        if (!popup) return;
        switch (popup.type) {
            case POPUP_CONSTANTS.SIMPLE_POPUP: {
                return <Popup {...popup} />;
            }
            case POPUP_CONSTANTS.SPINNER_POPUP: {
                return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
            }
            default: {
                console.warn('getPopupContent', popup.type);
                return null;
            }
        }
    };

    render() {
        const viewProps = this.getProps();
        const { popup } = this.state;
        return (
            <>
                {popup ? (
                    <PopupContainer> {this.getPopupContent()} </PopupContainer>
                ) : null}
                <ViewRenderer {...viewProps} />
            </>
        );
    }
}

const mapStateToProps = reduxProps => ({
    reduxProps,
});

const mapDispatchToProps = dispatch => ({});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TransactionReport),
);

